import {Action} from 'com/gongxigames/math/core/game/enums/Action';
import {GameHistoryEntry} from 'com/gongxigames/math/core/client/history/GameHistoryEntry';
import {GameHistoryEntryBuilder} from 'com/gongxigames/math/core/client/history/GameHistoryEntryBuilder';
import {Field} from 'com/gongxigames/math/core/game/message/Field';
import {Message} from 'com/gongxigames/math/core/game/message/Message';
import {consoleLogger} from '@gongxigames/framework/core';

export class WrapperUtils {

    public static getActionName(action: number): string {
        return (Action as any)['_$wrappers'][action].getName();
    }

    public static bytesToBase64(bytes: number[]): any {
        let binaryString = '';

        const len = bytes.length;

        for (let i = 0; i < len; i++) {
            binaryString += String.fromCharCode(bytes[i]);
        }

        return window.btoa(binaryString);

    }

    public static base64ToBytes(base64: string): number[] {
        const binaryString = window.atob(base64);
        const len = binaryString.length;
        const bytes = [];

        for (let i = 0; i < len; i++) {
            bytes[i] = binaryString.charCodeAt(i);
        }

        return bytes;
    }

    public static parseMessage(body: any, action: Action): Message {
        const data = body.data;

        if (data.player && data.player.balance >= 0) {
            data[Field.BALANCE] = Number(data.player.balance);
        }

        const response = new Message(action);

        for (const key of Object.keys(data)) {
            const value = this.parseFieldValue(key, data[key]);

            if (value != null) {
                response.addField(key, value);
            }
        }

        return response;
    }

    public static parseFieldValue(key: string, value: any): any {
        switch (key) {
            case Field.TIME:
                return value;
            case Field.BALANCE:
            case Field.ACTION_NUMBER:
                return Number(value);
            case Field.BINARY:
                return this.base64ToBytes(value);
            case Field.GAME_HISTORY:
                return this.parseGameHistoryArray(value);
            default:
                return null;
        }
    }

    public static parseGameHistoryArray(array: any[]): GameHistoryEntry[] {
        const result: GameHistoryEntry[] = [];

        for (const entry of array) {
            try {
                result.push(GameHistoryEntryBuilder.newBuilder()
                    .addActionNumber(entry[Field.ACTION_NUMBER])
                    .addSessionData(WrapperUtils.base64ToBytes(entry[Field.SESSION]))
                    .addRequestData(entry[Field.REQUEST])
                    .build());
            } catch (e) {
                consoleLogger.error('Failed to parse history entry:\n' + JSON.stringify(entry, undefined, 3));
                consoleLogger.error(e);
            }
        }

        return result;
    }
}
